// Third party
import React from 'react';

// Utils
import { getColorFromString } from '../../../utils/colors';

// Components
import Tooltip from '../tooltips/Tooltip';
import { ContactPastille } from '.';
import GenericContact from '@/types/generic-contact';

type Props = {
  contact: GenericContact;
  tooltipDisabled?: boolean;
};

const ContactInitialsLabel = (props: Props) => {
  const { contact, tooltipDisabled } = props;
  const contactColor = contact?._id ? getColorFromString(contact._id) : null;
  const backgroundColor = contactColor ? 'white' : 'transparent';
  const borderColor = contactColor || 'transparent';
  return (
    <Tooltip
      className="contact-initials-label"
      message={`${contact.fname} ${contact.lname}`}
      disabled={tooltipDisabled || (!contact.fname && !contact.lname)}
      data-private
      data-dd-privacy="mask"
    >
      <div>
        <ContactPastille contact={contact} backgroundColor={backgroundColor} borderColor={borderColor} />
      </div>
    </Tooltip>
  );
};

export default ContactInitialsLabel;
